import React, { useState, useEffect } from 'react';
import './ReportPopup.css';
import api from '../../api';

function ReportPopup({ onClose, onSubmit, reportedId, reporterUsername, type }) {
  const [reason, setReason] = useState('');
  const [details, setDetails] = useState('');
  const [alreadyReported, setAlreadyReported] = useState(false);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const checkAlreadyReported = async () => {
      try {
        const res = await api.get('/reports/check', {
          params: {
            reporterUsername,
            reportedId,
            reportedType: type
          }
        });
        setAlreadyReported(res.data.alreadyReported);
      } catch (err) {
        console.error('❌ Failed to check report status:', err);
      } finally {
        setChecking(false);
      }
    };

    checkAlreadyReported();
  }, [reporterUsername, reportedId, type]);

  const handleSubmit = () => {
    if (!reason) return alert('Please select a reason');
    onSubmit({
      reporterUsername,
      reportedType: type,
      reportedId,
      reason,
      details
    });
    onClose();
  };

  return (
    <div className="report-popup-backdrop" onClick={onClose}>
      <div className="report-popup" onClick={(e) => e.stopPropagation()}>
        <h3>Report {type === 'post' ? 'Post' : 'Product'}</h3>

        {checking ? (
          <p>Checking...</p>
        ) : alreadyReported ? (
          <p className="report-already-msg">✅ You've already reported this {type}.</p>
        ) : (
          <>
            <label>Reason:</label>
            <select value={reason} onChange={(e) => setReason(e.target.value)}>
              <option value="">-- Select --</option>
              <option value="Spam or misleading">Spam or misleading</option>
              <option value="Harassment or hate">Harassment or hate</option>
              <option value="False information">False information</option>
              <option value="Illegal activity">Illegal activity</option>
            </select>

            <label>Details (optional):</label>
            <textarea
              placeholder="Add any extra details..."
              value={details}
              onChange={(e) => setDetails(e.target.value)}
            />

            <button className="report-submit-btn" onClick={handleSubmit}>
              Submit Report
            </button>
          </>
        )}
      </div>
    </div>
  );
}

export default ReportPopup;
